// packages/shared-components/src/components/Section/Section.tsx

import { SectionProps } from "./types";
import styles from "./Section.module.css";

export function Section({
  title,
  titleAddon,
  description,
  rightContent,
  showDivider = false, // ← 新增：默认不显示分割线
  className = "",
  children,
  disabled = false,
}: SectionProps) {
  return (
    <div
      className={`${styles.section} ${className} ${disabled ? styles.disabled : ""}`}
    >
      {title && (
        <div
          className={`${styles.header} ${
            showDivider ? styles.withDivider : ""
          }`}
        >
          <div className={styles.headerLeft}>
            <div className={styles.titleRow}>
              <h3 className={styles.title}>{title}</h3>
              {titleAddon}
            </div>
            {description && <p className={styles.description}>{description}</p>}
          </div>
          {rightContent && (
            <div className={styles.rightContent}>{rightContent}</div>
          )}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}
